import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CURRENCY_LABEL, CustomEvents, MOMENT_DATE_FORMAT, Utils } from '@app/_helpers';
import { TransactionStatus } from '../../../modules/trading/modules/profile/components/plans/plans.enums';
import { TransactionHistoryService } from '@app/modules/trading/modules/profile/providers/transactions-history/transaction-history.service';
import { Router } from '@angular/router';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';
import { EventsService, SubjectType } from '@app/_shared/providers';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit, OnDestroy {
  public isLoading: boolean = true;
  public status: string = TransactionStatus.PENDING;
  public amount: number;
  public planName: string;
  public validity: string;
  public invoiceID: string;
  public isAdvancePayment: boolean = false;


  private CURRENCY_LABEL = CURRENCY_LABEL;
  public TransactionStatus = TransactionStatus;
  subscriptions = new Subscription();
  result: any;
  HDFCWindowClosed: boolean;
  brokerPlanBrokerageValue: number;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private booksSocketService: BooksSocketService,
    private transactionHistoryService: TransactionHistoryService,
    private eventService: EventsService,
    private router: Router,
    private dialogRef: MatDialogRef<PaymentResultComponent>) {
      this.eventService.subscribe(CustomEvents.HDFCWindowClosed, (flag) => {
        if(flag && this.status === TransactionStatus.PENDING){
          this.HDFCWindowClosed = true;
          this.isLoading = false;
        }
      });
    }

  ngOnInit(): void {
    this.subscriptions.add(
      this.booksSocketService.getSubject(SubjectType.SUBSCRIPTION).subscribe((response) => {
        this.result = response;
        if (response?.status) {
          this.isLoading = false;
          this.status = response.status;
          this.amount = response.amount;
          this.invoiceID = response.invoiceID;
          this.planName = response.planName;
          this.validity = Utils.getDateOnlyFromEpoch(response.endDate);
          this.isAdvancePayment = response.isAdvancePayment;
        } else {
          this.dialogRef.close();
        }
      })
    )
    this.brokerPlanBrokerageValue = this.data.brokerPlanBrokerageValue;
  }

  route() {
    if (this.status === TransactionStatus.SUCCESS) {
      this.router.navigate(['/trading/profile/transaction-history'])
    } else if (this.status === TransactionStatus.FAILED || this.status === TransactionStatus.CANCELLED) {
      this.router.navigate(['/trading/profile/help'])
    }
    this.eventService.publish(CustomEvents.PaymentDialog);
    this.eventService.publish(CustomEvents.PlanDialog);
    this.dialogRef.close();
  }

  action() {
    if (this.status === TransactionStatus.SUCCESS) {
      this.transactionHistoryService.downloadInvoice(this.invoiceID).subscribe(res => {
        window.open(res.download_url, "_blank");
      })
    } else if (this.status === TransactionStatus.FAILED || this.status === TransactionStatus.CANCELLED || this.status === TransactionStatus.PENDING) {
      this.dialogRef.close();
    }
  }

  get isFailed() {
    return this.status === TransactionStatus.FAILED || this.status === TransactionStatus.CANCELLED || (this.HDFCWindowClosed && this.status == TransactionStatus.PENDING);
  }

  closeDialog() {
    this.dialogRef.close(this.result);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  routeToTransactionHistory() {
    this.router.navigate(['/trading/profile/transaction-history']);
    this.dialogRef.close();
  }

}
